import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects'
import { kegSizes } from '../../config'
import { defineTypes } from '../../helpers'
import { reduxFetch } from '../../http/reduxFetch'
import ProductsEndpoint from '../../persistence/ProductsEndpoint'
import { actions as productActions } from '../products'
import { selectors as productSelectors } from '../products/show'
import { push } from 'react-router-redux'
import Alert from 'react-s-alert';
import _ from 'lodash'

const updateProduct = { ...defineTypes('UPDATE_PRODUCT') }

export const initialState = {
  started: false,
  loading: false,
  loaded: false,
  alwaysOnKegSizes: [],
  errors: {}
}

export const actions = {
  updateProduct (id) {
    return { type: 'UPDATE_PRODUCT_FORM', id: id }
  },
  setImageUrl (image_url) {
    return { type: 'SET_IMAGE_URL', image_url: image_url }
  },
  clearErrors() {
    return { type: 'CLEAR_ERRORS' }
  },
  toggleAlwaysOn(keg_size, product) {
    return { type: 'SET_ALWAYS_AVAILABLE_INVENTORY', keg_size: keg_size, product: product }
  }
}

export const reducer = (state = initialState, action ) => {
  switch (action.type) {
    case 'UPDATE_PRODUCT_FORM':
      return { ...state, started: true, loading: true, id: action.id }
    case updateProduct.FAILURE:
      return { ...state, loading: false, errors: action.errors }
    case updateProduct.SUCCESS:
      return { ...state, loading: false, loaded: true, errors: {} }
    case 'SET_IMAGE_URL':
      return { ...state, image_url: action.image_url }
    case 'CLEAR_ERRORS':
      return { ...state, errors: {} }
    default:
      return state
  }
}

export const selectors = {
  update_product_form: (store) => {
    return store.form.update_product
  },
  product_image_url: (store) => {
    return store.update_product['image_url'] || null
  },
  errors: (store) => {
    return store.update_product['errors']
  },
  loading: (store) => {
    return store.update_product['loading']
  }
}

const build_prices = (values) => {
  let prices = {}
  Object.keys(values).forEach(key => {
    if (kegSizes.includes(_.snakeCase(key))) {
      prices[_.snakeCase(key)] = values[key]
    }
  })
  return prices
}

const buildAlwaysOnQuantity = (values) => {
  let alwaysOnQuantity = {}
  kegSizes.forEach(kegSize => {
    if (values[`${_.camelCase(kegSize)}Quantity`]) {
      alwaysOnQuantity[_.snakeCase(kegSize)] = values[`${_.camelCase(kegSize)}Quantity`]
    }
  })
  return alwaysOnQuantity
}

export function * updateProductSaga (action) {
  try {
    yield takeLatest(updateProduct.SUCCESS, productSuccess)
    const form = yield select(selectors.update_product_form)
    const image_url = yield select(selectors.product_image_url)
    const alwaysOnInventory  = yield select(productSelectors.alwaysOnKegSizes)
    const update_product = form['values']
    update_product['image_url'] = image_url || null
    update_product['prices'] = build_prices(form['values'])
    update_product['always_on_inventory'] =  alwaysOnInventory
    update_product['always_on_quantity'] = buildAlwaysOnQuantity(form['values'])
    const update_product_response = yield call(reduxFetch, ProductsEndpoint.update(action.id, update_product))
    if ( update_product_response['data'] ) {
      yield put({ type: updateProduct.SUCCESS, update_product: update_product_response.data })
      yield call(Alert.success, '<div>Product Updated!</div>')
    } else {
      yield put({ type: updateProduct.FAILURE, errors: update_product_response.errors })
    }
  } catch (error) {
    yield put({ type: updateProduct.FAILURE, errors: error })
  }
}

export function * productSuccess (action) {
  try {
    yield call(productActions.getProducts)
  } catch (error) {
    yield put({type: updateProduct.FAILURE, errors: error })
  }
}

function * handleAlwaysOnInventory (action) {
  try {
    let always_on = yield select(productSelectors.alwaysOnKegSizes)
    let product_id = action && action.product && action.product.id
    if (always_on.includes(action.keg_size)) {
      yield put.resolve({ type: 'REMOVE_KEG_SIZE', keg_size: action.keg_size })
      yield put({ type: 'UPDATE_PRODUCT_FORM', id: product_id })
    } else {
      yield put.resolve({ type: 'ADD_KEG_SIZE', keg_size: action.keg_size })
      yield put({ type: 'UPDATE_PRODUCT_FORM', id: product_id })
    }
  } catch (error) {
    yield put({type: updateProduct.FAILURE, errors: error })
  }
}

export function * rootSaga () {
  yield takeLatest('UPDATE_PRODUCT_FORM', updateProductSaga)
  yield takeEvery('SET_ALWAYS_AVAILABLE_INVENTORY', handleAlwaysOnInventory)
}



// WEBPACK FOOTER //
// ./src/sagas/products/update.js